import { useRouter } from 'next/router'

import {
  PENGELOLAAN_KINERJA_TK_PENILIK_PATH,
  PENGELOLAAN_KINERJA_PPK_PENILIK_PATH,
} from 'app/KinerjaShared/constants/path'
import { getBasePath } from '../utils/path'

export default function useBasePath() {
  const router = useRouter()
  const currentPath = router?.asPath ?? ''

  const isTKPenilikUrl = currentPath.includes(
    PENGELOLAAN_KINERJA_TK_PENILIK_PATH
  )
  const isPPKPenilikUrl = currentPath.includes(
    PENGELOLAAN_KINERJA_PPK_PENILIK_PATH
  )

  const basePath = getBasePath(isTKPenilikUrl, isPPKPenilikUrl)

  return { basePath, isTKPenilikUrl, isPPKPenilikUrl }
}
